<template>
  <div class="header">
    <Desktop v-if="!mobile" :menu="menu" />
    <Mobile v-else :menu="menu" />
  </div>
</template>

<script>
import Desktop from "./Desktop.vue";
import Mobile from "./Mobile.vue";
import { menu } from "../../../config";

export default {
  data: () => ({
    menu,
  }),
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    Desktop,
    Mobile,
  },
};
</script>

<style lang="scss" scoped>
.header {
  box-shadow: 0px 4px 8px rgba(133, 136, 140, 0.12) !important;
  position: relative;
  z-index: 10;
  @media screen and (max-width: 960px) {
    margin-bottom: 56px;
    z-index: initial;
  }
}
</style>
